// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xmAA5L{padding:12px 18px !important;height:54px}.svk2E0{border-radius:6px;border:1px solid var(--wsr-color-D60, #dfe5eb)}.zVvRar{border-radius:4px;border:solid 1px #dfe5eb}.t4kF97{box-sizing:border-box}.t4kF97{color:#7a92a5}.CfDP7R{display:flex;align-items:center}.Vvgh6k{margin-right:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"installed-plugin-list-item-container": `xmAA5L`,
	"installedPluginListItemContainer": `xmAA5L`,
	"plugin-card": `svk2E0`,
	"pluginCard": `svk2E0`,
	"plugin-icon": `zVvRar`,
	"pluginIcon": `zVvRar`,
	"plugin-details": `t4kF97`,
	"pluginDetails": `t4kF97`,
	"plugin-installed": `CfDP7R`,
	"pluginInstalled": `CfDP7R`,
	"plugin-installed-icon": `Vvgh6k`,
	"pluginInstalledIcon": `Vvgh6k`
};
export default ___CSS_LOADER_EXPORT___;
